import Skeleton from '../shared/Skeleton';

interface DetailRowProps {
  title: string;
  value?: string;
  loading?: boolean;
  containerClasses?: string;
  leftColClasses?: string;
  rightColClasses?: string;
}

export function DetailRow({
  title,
  value,
  loading,
  containerClasses = 'sm:grid sm:grid-cols-3 sm:gap-4',
  leftColClasses,
  rightColClasses = 'sm:col-span-2',
}: DetailRowProps) {
  return (
    <div className={`px-2 py-3 sm:px-0 ${containerClasses}`}>
      <dt
        className={`text-sm/6 font-medium text-gray-900 dark:text-gray-100 ${leftColClasses}`}
      >
        {title}
      </dt>
      <dd
        className={`mt-1 text-sm/6 text-gray-700 sm:mt-0 dark:text-gray-400 ${rightColClasses}`}
      >
        {loading ? <Skeleton className="h-4 w-3/4" /> : (value ?? 'N/A')}
      </dd>
    </div>
  );
}
